"use client";
import Image from "next/image";
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Link from "next/link";

function StackCard() {
  // State to delay rendering of lower sections
  const [showRest, setShowRest] = useState(false);

  useEffect(() => {
    // Delay rendering of lower sections for 300ms
    const timer = setTimeout(() => setShowRest(true), 300);
    return () => clearTimeout(timer);
  }, []);

  // Simple skeleton placeholder
  const ImgSkeleton = ({ width, height }) => (
    <div
      style={{
        width,
        height,
        background: "#f3f3f3",
        borderRadius: 8,
        display: "inline-block",
        animation: "pulse 1.5s infinite",
      }}
      className="img-skeleton"
    />
  );

  return (
    <motion.div
      style={{ width: "100%", background: "white !important" }}
      className="stack-card-container"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      <div className="steps-container1 thq-section-padding">
        <div className="steps-container3">
          <motion.div
            className="steps-container4 thq-card4"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* Left Hand side */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.2 }}
              >
                <motion.h1
                  className="steps-container--title"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: 0.3 }}
                >
                  Connecting Africa through Remittance
                </motion.h1>

                <motion.p
                  className="steps-container--subtitleText"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: 0.5 }}
                >
                  Effortlessly send money across Africa with fast, secure, and
                  low-cost transfers.
                </motion.p>
                <motion.div
                  className="steps-container--descCard"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: 0.6 }}
                >
                  <div className="steps-container--desc">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.29354 1.00398C6.68407 0.613457 7.31723 0.613458 7.70776 1.00398L12.9602 6.25644C13.3507 6.64696 13.3507 7.28012 12.9602 7.67065L7.70776 12.9231C7.31723 13.3136 6.68407 13.3136 6.29354 12.9231L1.04109 7.67065C0.650566 7.28012 0.650567 6.64696 1.04109 6.25643L6.29354 1.00398Z"
                        fill="#042656"
                      />
                    </svg>
                    <p className="steps-container--descText">Low Fees</p>
                  </div>
                  <div className="steps-container--desc">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.29354 1.00398C6.68407 0.613457 7.31723 0.613458 7.70776 1.00398L12.9602 6.25644C13.3507 6.64696 13.3507 7.28012 12.9602 7.67065L7.70776 12.9231C7.31723 13.3136 6.68407 13.3136 6.29354 12.9231L1.04109 7.67065C0.650566 7.28012 0.650567 6.64696 1.04109 6.25643L6.29354 1.00398Z"
                        fill="#042656"
                      />
                    </svg>
                    <p className="steps-container--descText">
                      Effortless Global Transfers
                    </p>
                  </div>
                  <div className="steps-container--desc">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.29354 1.00398C6.68407 0.613457 7.31723 0.613458 7.70776 1.00398L12.9602 6.25644C13.3507 6.64696 13.3507 7.28012 12.9602 7.67065L7.70776 12.9231C7.31723 13.3136 6.68407 13.3136 6.29354 12.9231L1.04109 7.67065C0.650566 7.28012 0.650567 6.64696 1.04109 6.25643L6.29354 1.00398Z"
                        fill="#042656"
                      />
                    </svg>
                    <p className="steps-container--descText">Global Reach</p>
                  </div>
                </motion.div>
                <motion.div
                  className="steps-container--imgCard"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: 0.6 }}
                >
                  <Image
                    src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918908/Frame_2147223394_amvqdl.png"
                    width={495}
                    height={199}
                    alt="steps-image"
                    priority
                  />
                </motion.div>
                <Link href={"/african-remittance" || "#"}>
                  <motion.button
                    className="btn btn--warning "
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.7 }}
                  >
                    Send Money Now
                  </motion.button>
                </Link>
              </motion.div>
              {/* Right Hand Side */}
              <motion.div
                className="step-container--img"
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.3 }}
              >
                <React.Suspense
                  fallback={<ImgSkeleton width={800} height={600} />}
                >
                  <Image
                    src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918909/image_102_w6an9k.png"
                    width={800}
                    height={600}
                    alt="steps-image"
                    priority
                  />
                </React.Suspense>
                <div className="step-container-phoneImg">
                  <React.Suspense
                    fallback={<ImgSkeleton width={300} height={533} />}
                  >
                    <Image
                      src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918909/image_103_bxy6hk.png"
                      width={300}
                      height={533}
                      alt="steps-image"
                      loading="lazy"
                    />
                  </React.Suspense>
                </div>
              </motion.div>
            </div>
          </motion.div>
          {/* Delay rendering of the rest for faster initial paint */}
          {showRest && (
            <>
              {/* steps-container5 */}
              <motion.div
                className="steps-container5 thq-card5"
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.2 }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  {/* Left Hand side */}
                  <motion.div
                    className="step-container--img"
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.3 }}
                  >
                    <React.Suspense
                      fallback={<ImgSkeleton width={800} height={600} />}
                    >
                      <Image
                        src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918909/image_109_zxe4b9.png"
                        width={800}
                        height={600}
                        alt="steps-image"
                        loading="lazy"
                      />
                    </React.Suspense>
                    <div className="step-container-phoneImg5">
                      <React.Suspense
                        fallback={<ImgSkeleton width={300} height={533} />}
                      >
                        <Image
                          src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918909/image_104_uweale.png"
                          width={300}
                          height={533}
                          alt="steps-image"
                          loading="lazy"
                        />
                      </React.Suspense>
                    </div>
                  </motion.div>
                  {/* Right Hand Side */}
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.4 }}
                  >
                    <motion.h1
                      className="steps-container--title"
                      initial={{ opacity: 0, y: 30 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.5 }}
                    >
                      Smart Currency Exchange
                    </motion.h1>

                    <motion.p
                      className="steps-container--subtitleText"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.7 }}
                    >
                      Experience hassle-free currency exchange with competitive
                      rates and transparent fees.
                    </motion.p>
                    <motion.div
                      className="steps-container--descCard"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.8 }}
                    >
                      <div className="steps-container--desc">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.29354 1.00398C6.68407 0.613457 7.31723 0.613458 7.70776 1.00398L12.9602 6.25644C13.3507 6.64696 13.3507 7.28012 12.9602 7.67065L7.70776 12.9231C7.31723 13.3136 6.68407 13.3136 6.29354 12.9231L1.04109 7.67065C0.650566 7.28012 0.650567 6.64696 1.04109 6.25643L6.29354 1.00398Z"
                            fill="#042656"
                          />
                        </svg>
                        <p className="steps-container--descText">Best Rates</p>
                      </div>
                      <div className="steps-container--desc">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.29354 1.00398C6.68407 0.613457 7.31723 0.613458 7.70776 1.00398L12.9602 6.25644C13.3507 6.64696 13.3507 7.28012 12.9602 7.67065L7.70776 12.9231C7.31723 13.3136 6.68407 13.3136 6.29354 12.9231L1.04109 7.67065C0.650566 7.28012 0.650567 6.64696 1.04109 6.25643L6.29354 1.00398Z"
                            fill="#042656"
                          />
                        </svg>
                        <p className="steps-container--descText">
                          Instant Exchange
                        </p>
                      </div>
                      <div className="steps-container--desc">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.29354 1.00398C6.68407 0.613457 7.31723 0.613458 7.70776 1.00398L12.9602 6.25644C13.3507 6.64696 13.3507 7.28012 12.9602 7.67065L7.70776 12.9231C7.31723 13.3136 6.68407 13.3136 6.29354 12.9231L1.04109 7.67065C0.650566 7.28012 0.650567 6.64696 1.04109 6.25643L6.29354 1.00398Z"
                            fill="#042656"
                          />
                        </svg>
                        <p className="steps-container--descText">
                          Zero Hidden Fees
                        </p>
                      </div>
                    </motion.div>
                    <motion.div
                      className="steps-container--imgCard-2"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.6 }}
                    >
                      <Image
                        src=""
                        width={248}
                        height={171}
                        alt="steps-image"
                        priority
                      />
                    </motion.div>
                    <Link href={"/currency-exchange" || "#"}>
                      <motion.button
                        className="btn btn--warning "
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 0.9 }}
                      >
                        Convert Currency Instantly
                      </motion.button>
                    </Link>
                  </motion.div>
                </div>
              </motion.div>
              {/* steps-container6 */}
              <motion.div
                className="steps-container6 thq-card4"
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.3 }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {/* Left Hand side */}
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.4 }}
                  >
                    <motion.h1
                      className="steps-container--title"
                      initial={{ opacity: 0, y: 30 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.5 }}
                    >
                      Swift Money Transfer
                    </motion.h1>
                    <motion.p
                      className="steps-container--subtitleText"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.7 }}
                    >
                      Send money with confidence using our trusted and secure
                      transfer solutions.
                    </motion.p>
                    <motion.div
                      className="steps-container--descCard"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.8 }}
                    >
                      <div className="steps-container--desc">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.29354 1.00398C6.68407 0.613457 7.31723 0.613458 7.70776 1.00398L12.9602 6.25644C13.3507 6.64696 13.3507 7.28012 12.9602 7.67065L7.70776 12.9231C7.31723 13.3136 6.68407 13.3136 6.29354 12.9231L1.04109 7.67065C0.650566 7.28012 0.650567 6.64696 1.04109 6.25643L6.29354 1.00398Z"
                            fill="#042656"
                          />
                        </svg>
                        <p className="steps-container--descText">
                          Instant Delivery
                        </p>
                      </div>
                      <div className="steps-container--desc">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.29354 1.00398C6.68407 0.613457 7.31723 0.613458 7.70776 1.00398L12.9602 6.25644C13.3507 6.64696 13.3507 7.28012 12.9602 7.67065L7.70776 12.9231C7.31723 13.3136 6.68407 13.3136 6.29354 12.9231L1.04109 7.67065C0.650566 7.28012 0.650567 6.64696 1.04109 6.25643L6.29354 1.00398Z"
                            fill="#042656"
                          />
                        </svg>
                        <p className="steps-container--descText">
                          Unwavering Security
                        </p>
                      </div>
                      <div className="steps-container--desc">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.29354 1.00398C6.68407 0.613457 7.31723 0.613458 7.70776 1.00398L12.9602 6.25644C13.3507 6.64696 13.3507 7.28012 12.9602 7.67065L7.70776 12.9231C7.31723 13.3136 6.68407 13.3136 6.29354 12.9231L1.04109 7.67065C0.650566 7.28012 0.650567 6.64696 1.04109 6.25643L6.29354 1.00398Z"
                            fill="#042656"
                          />
                        </svg>
                        <p className="steps-container--descText">
                          Guaranteed Arrival
                        </p>
                      </div>
                    </motion.div>
                    <motion.div
                      className="steps-container--imgCard-4"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.6 }}
                    >
                      <Image
                        src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918908/Frame_2147223396_unhfy5.png"
                        width={154}
                        height={174}
                        alt="steps-image"
                        priority
                      />
                      <span className="step-container-arrow">
                        <svg
                          width="178"
                          height="65"
                          viewBox="0 0 235 74"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M231.092 48.289C230.28 48.3337 228.155 48.5303 226.341 48.7892C222.259 49.3716 215.679 48.7801 209.349 47.1229C204.513 45.9087 202.482 46.0205 202.038 47.5254C201.433 49.5162 207.926 52.4872 215.146 53.6036C217.331 53.9503 219.157 54.2769 219.284 54.419C219.835 55.0345 209.016 57.0412 203.426 57.354C192.233 57.9903 179.691 55.5821 167.289 50.4824C159.371 47.252 152.475 43.5443 137.719 34.7538C131.625 31.0851 123.677 26.869 120.117 25.366C109.695 21.0514 104.829 20.4711 90.4153 21.6871C88.9701 21.7866 88.6687 21.5448 86.8128 18.5172C84.374 14.6473 78.4948 8.83679 74.663 6.55388C60.6987 -1.91142 41.4365 -0.875516 21.8439 9.31971C11.9737 14.4835 1.99679 22.47 0.568504 26.3045C0.349133 27.0121 0.520929 27.9664 0.944444 28.4399C1.70677 29.2921 2.12292 29.0904 5.76871 25.8293C7.94671 23.8812 12.5892 20.4957 16.032 18.3536C38.6824 4.14478 59.903 1.77268 74.3629 11.8402C77.6516 14.1828 84.6442 21.8099 84.5743 23.0657C84.5643 23.2451 83.2162 24.0248 81.5567 24.7422C79.3439 25.6986 76.7174 27.6218 72.0832 31.767C66.5436 36.7221 65.4395 37.9653 63.9724 40.9822C59.9821 48.8129 59.6831 55.8988 63.0633 60.5354C65.5744 63.9144 67.0966 64.854 70.717 65.2806C75.9892 65.9342 78.7925 64.8756 83.9949 60.2223C88.2562 56.4107 88.5976 55.9348 90.5293 51.1386C92.9322 45.154 93.5927 37.2334 92.1861 31.0872C91.6358 28.8521 91.3445 26.8113 91.4866 26.6843C92.2915 25.9643 102.657 25.6419 106.346 26.3479C115.219 27.7869 120.518 30.2809 139.634 41.5638C163.803 55.8162 176.705 60.6289 194.281 61.6979C202.576 62.2049 209.079 61.7573 216.132 60.1257L219.554 59.2815L216.536 62.5775C212.945 66.4715 210.886 71.1256 212.052 72.8102C213.128 74.4897 214.665 73.5406 217.933 68.9988C219.535 66.8836 223.657 62.3444 227.17 58.9466C230.688 55.5435 233.754 52.2051 234.015 51.5448C234.23 50.9269 234.016 49.9252 233.465 49.3097C232.914 48.6942 231.858 48.2754 231.093 48.2778L231.092 48.289ZM87.8093 32.1256C88.9224 37.1813 88.0542 44.6911 85.9237 49.8248C82.6036 57.7379 75.4753 62.239 69.7397 60.2099C67.6219 59.4621 67.4525 59.2727 66.394 56.4694C64.4686 51.4584 66.0966 45.6556 71.3141 39.1135C73.0586 36.8713 75.6354 34.2255 77.1305 33.2291C80.3626 30.9347 86.4302 27.8086 86.8114 28.2347C86.9384 28.3767 87.424 30.1583 87.81 32.1144L87.8093 32.1256Z"
                            fill="#1D57A8"
                          />
                        </svg>
                      </span>
                    </motion.div>
                    <div style={{ display: "flex", gap: "50px" }}>
                      <Link href={"/money-transfer" || "#"}>
                        <motion.button
                          className="btn btn--warning "
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.7, delay: 0.9 }}
                        >
                          Start a Quick Transfer
                        </motion.button>
                      </Link>
                    </div>
                  </motion.div>
                  {/* Right Hand Side */}
                  <motion.div
                    className="step-container--img"
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.5 }}
                  >
                    <React.Suspense
                      fallback={<ImgSkeleton width={800} height={600} />}
                    >
                      <Image
                        src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918910/image_107_zjmkgv.png"
                        width={800}
                        height={600}
                        alt="steps-image"
                        loading="lazy"
                      />
                    </React.Suspense>
                    <div className="step-container-phoneImg">
                      <React.Suspense
                        fallback={<ImgSkeleton width={300} height={533} />}
                      >
                        <Image
                          src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918910/image_108_ua7oju.png"
                          width={300}
                          height={533}
                          alt="steps-image"
                          loading="lazy"
                        />
                      </React.Suspense>
                    </div>
                  </motion.div>
                </div>
              </motion.div>
              {/* steps-container7 */}
              <motion.div
                className="steps-container7 thq-card5"
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.4 }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  {/* Left Hand side */}
                  <motion.div
                    className="step-container--img"
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.5 }}
                  >
                    <React.Suspense
                      fallback={<ImgSkeleton width={800} height={600} />}
                    >
                      <Image
                        src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918323/image_115_fxh5dd.png"
                        width={800}
                        height={600}
                        alt="steps-image"
                        loading="lazy"
                      />
                    </React.Suspense>
                    <div className="step-container-phoneImg5">
                      <React.Suspense
                        fallback={<ImgSkeleton width={300} height={533} />}
                      >
                        <Image
                          src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918323/image_116_vgtmly.png"
                          width={300}
                          height={533}
                          alt="steps-image"
                          loading="lazy"
                        />
                      </React.Suspense>
                    </div>
                  </motion.div>
                  {/* Right Hand Side */}
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.6 }}
                  >
                    <motion.h1
                      className="steps-container--title"
                      initial={{ opacity: 0, y: 30 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.7 }}
                    >
                      Pay Your Bills, Effortlessly
                    </motion.h1>
                    <motion.p
                      className="steps-container--subtitleText"
                      style={{ marginTop: "30px" }}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.8 }}
                    >
                      Manage all your payments in one secure place. Fast,
                      reliable, and always on time.
                    </motion.p>
                    <motion.div
                      className="steps-container--descCard"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.9 }}
                    >
                      <div className="steps-container--desc">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 22.9609C17.5 22.9609 22 18.4609 22 12.9609C22 7.46094 17.5 2.96094 12 2.96094C6.5 2.96094 2 7.46094 2 12.9609C2 18.4609 6.5 22.9609 12 22.9609Z"
                            fill="#008000"
                            stroke="#008000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.75 12.9628L10.58 15.7928L16.25 10.1328"
                            stroke="#E7EFEC"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <p className="steps-container--descText">
                          Instant Confirmation
                        </p>
                      </div>
                      <div className="steps-container--desc">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 22.9609C17.5 22.9609 22 18.4609 22 12.9609C22 7.46094 17.5 2.96094 12 2.96094C6.5 2.96094 2 7.46094 2 12.9609C2 18.4609 6.5 22.9609 12 22.9609Z"
                            fill="#008000"
                            stroke="#008000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.75 12.9628L10.58 15.7928L16.25 10.1328"
                            stroke="#E7EFEC"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <p className="steps-container--descText">
                          Secure Transactions
                        </p>
                      </div>
                      <div className="steps-container--desc">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 22.9609C17.5 22.9609 22 18.4609 22 12.9609C22 7.46094 17.5 2.96094 12 2.96094C6.5 2.96094 2 7.46094 2 12.9609C2 18.4609 6.5 22.9609 12 22.9609Z"
                            fill="#008000"
                            stroke="#008000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.75 12.9628L10.58 15.7928L16.25 10.1328"
                            stroke="#E7EFEC"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <p className="steps-container--descText">
                          Scheduled Payments
                        </p>
                      </div>
                    </motion.div>
                    <motion.div
                      className="steps-container--imgCard-5"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.7, delay: 0.6 }}
                    >
                      <Image
                        src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918527/Frame_635381_qfsv3f.png"
                        width={248}
                        height={171}
                        alt="steps-image"
                        priority
                      />
                      <Image
                        src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754918527/Frame_2147223392_yvzr6f.png"
                        width={248}
                        height={171}
                        alt="steps-image"
                        priority
                      />
                    </motion.div>
                    <Link href={"/explore" || "#"}>
                      <motion.button
                        className="btn btn--warning "
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 1.0 }}
                      >
                        Pay a Bill Now
                      </motion.button>
                    </Link>
                  </motion.div>
                </div>
              </motion.div>
            </>
          )}
        </div>
      </div>
    </motion.div>
  );
}

export default StackCard;
